import { Map as GoogleMap, useMap } from "@vis.gl/react-google-maps"
import dynamic from "next/dynamic"
import React, { useEffect } from "react"

export interface MapProps {
  initialRegion: {
    latitude: number
    longitude: number
  }
  center?: {
    lat: number
    lng: number
  }
  children?: React.ReactNode
  onClick?: () => void
  onDragStart?: () => void
}

const LAT_LNG_BOUNDS_DELTA = 0.3

const MapContainer = ({ initialRegion, children, onClick, onDragStart, center }: MapProps) => {
  const defaultCenter = {
    lat: initialRegion.latitude,
    lng: initialRegion.longitude,
  }
  const map = useMap()

  useEffect(() => {
    if (map && center) {
      map.panTo(center)
    }
  }, [center, map])

  return (
    <GoogleMap
      className="size-full overflow-hidden rounded-lg"
      defaultCenter={defaultCenter}
      defaultZoom={13}
      onDragstart={onDragStart}
      gestureHandling="greedy"
      disableDefaultUI
      reuseMaps={true}
      minZoom={11}
      maxZoom={15}
      clickableIcons={false}
      mapId="baf29dad78527709"
      restriction={{
        latLngBounds: {
          north: initialRegion.latitude + LAT_LNG_BOUNDS_DELTA,
          south: initialRegion.latitude - LAT_LNG_BOUNDS_DELTA,
          east: initialRegion.longitude + LAT_LNG_BOUNDS_DELTA,
          west: initialRegion.longitude - LAT_LNG_BOUNDS_DELTA,
        },
      }}
      onClick={onClick}>
      {children}
    </GoogleMap>
  )
}

export default dynamic(() => Promise.resolve(MapContainer), { ssr: false })
